import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import Vue from 'vue';
import QItem from "../item/QItem.js";
import QItemSection from "../item/QItemSection.js";
import QItemLabel from "../item/QItemLabel.js";
import QIcon from "../icon/QIcon.js";
import QSlideTransition from "../slide-transition/QSlideTransition.js";
import QSeparator from "../separator/QSeparator.js";
import RouterLinkMixin from "../../mixins/router-link.js";
import ModelToggleMixin from "../../mixins/model-toggle.js";
import DarkMixin from "../../mixins/dark.js";
import { stopAndPrevent } from "../../utils/event.js";
import { slot } from "../../utils/slot.js";
import cache from "../../utils/cache.js";
var eventName = 'q:expansion-item:close';
export default Vue.extend({
  name: 'QExpansionItem',
  mixins: [DarkMixin, RouterLinkMixin, ModelToggleMixin],
  props: {
    icon: String,
    label: String,
    labelLines: [Number, String],
    caption: String,
    captionLines: [Number, String],
    dense: Boolean,
    expandIcon: String,
    expandedIcon: String,
    expandIconClass: [Array, String, Object],
    duration: Number,
    headerInsetLevel: Number,
    contentInsetLevel: Number,
    expandSeparator: Boolean,
    defaultOpened: Boolean,
    expandIconToggle: Boolean,
    switchToggleSide: Boolean,
    denseToggle: Boolean,
    group: String,
    popup: Boolean,
    headerStyle: [Array, String, Object],
    headerClass: [Array, String, Object]
  },
  data: function data() {
    return {
      showing: this.value !== void 0 ? this.value : this.defaultOpened
    };
  },
  watch: {
    showing: function showing(val) {
      val === true && this.group !== void 0 && this.$root.$emit(eventName, this);
    },
    group: function group(newVal, oldVal) {
      if (newVal !== void 0 && oldVal === void 0) {
        this.$root.$on(eventName, this.__eventHandler);
      } else if (newVal === void 0 && oldVal !== void 0) {
        this.$root.$off(eventName, this.__eventHandler);
      }
    }
  },
  computed: {
    classes: function classes() {
      return "q-expansion-item--".concat(this.showing === true ? 'expanded' : 'collapsed') + " q-expansion-item--".concat(this.popup === true ? 'popup' : 'standard');
    },
    contentStyle: function contentStyle() {
      if (this.contentInsetLevel !== void 0) {
        var dir = this.$q.lang.rtl === true ? 'Right' : 'Left';
        return _defineProperty({}, 'padding' + dir, this.contentInsetLevel * 56 + 'px');
      }
    },
    isClickable: function isClickable() {
      return this.hasLink === true || this.expandIconToggle !== true;
    },
    expansionIcon: function expansionIcon() {
      return this.expandedIcon !== void 0 && this.showing === true ? this.expandedIcon : this.expandIcon || this.$q.iconSet.expansionItem[this.denseToggle === true ? 'denseIcon' : 'icon'];
    },
    activeToggleIcon: function activeToggleIcon() {
      return this.disable !== true && (this.hasLink === true || this.expandIconToggle === true);
    }
  },
  methods: {
    __onHeaderClick: function __onHeaderClick(e) {
      this.hasLink !== true && this.toggle(e);
      this.$emit('click', e);
    },
    __toggleIconKeyboard: function __toggleIconKeyboard(e) {
      e.keyCode === 13 && this.__toggleIcon(e, true);
    },
    __toggleIcon: function __toggleIcon(e, keyboard) {
      keyboard !== true && this.$refs.blurTarget !== void 0 && this.$refs.blurTarget.focus();
      this.toggle(e);
      stopAndPrevent(e);
    },
    __eventHandler: function __eventHandler(comp) {
      this !== comp && this.group === comp.group && this.hide();
    },
    __getToggleIcon: function __getToggleIcon(h) {
      var data = {
        staticClass: "q-focusable relative-position cursor-pointer".concat(this.denseToggle === true && this.switchToggleSide === true ? ' items-end' : ''),
        class: this.expandIconClass,
        props: {
          side: this.switchToggleSide !== true,
          avatar: this.switchToggleSide
        }
      };
      var child = [h(QIcon, {
        staticClass: 'q-expansion-item__toggle-icon',
        class: this.expandedIcon === void 0 && this.showing === true ? 'q-expansion-item__toggle-icon--rotated' : void 0,
        props: {
          name: this.expansionIcon
        }
      })];

      if (this.activeToggleIcon === true) {
        Object.assign(data, {
          attrs: {
            tabindex: 0
          },
          on: cache(this, 'inpExt', {
            click: this.__toggleIcon,
            keyup: this.__toggleIconKeyboard
          })
        });
        child.unshift(h('div', {
          ref: 'blurTarget',
          staticClass: 'q-expansion-item__toggle-focus q-icon q-focus-helper q-focus-helper--rounded',
          attrs: {
            tabindex: -1
          }
        }));
      }

      return h(QItemSection, data, child);
    },
    __getHeader: function __getHeader(h) {
      var child;

      if (this.$scopedSlots.header !== void 0) {
        child = [].concat(this.$scopedSlots.header());
      } else {
        child = [h(QItemSection, [h(QItemLabel, {
          props: {
            lines: this.labelLines
          }
        }, [this.label || '']), this.caption ? h(QItemLabel, {
          props: {
            lines: this.captionLines,
            caption: true
          }
        }, [this.caption]) : null])];
        this.icon && child[this.switchToggleSide === true ? 'push' : 'unshift'](h(QItemSection, {
          props: {
            side: this.switchToggleSide === true,
            avatar: this.switchToggleSide !== true
          }
        }, [h(QIcon, {
          props: {
            name: this.icon
          }
        })]));
      }

      this.disable !== true && child[this.switchToggleSide === true ? 'unshift' : 'push'](this.__getToggleIcon(h));
      var data = {
        ref: 'item',
        style: this.headerStyle,
        class: this.headerClass,
        props: {
          dark: this.isDark,
          disable: this.disable,
          dense: this.dense,
          insetLevel: this.headerInsetLevel
        }
      };

      if (this.isClickable === true) {
        data.props.clickable = true;
        data[this.hasRouterLink === true ? 'nativeOn' : 'on'] = _objectSpread(_objectSpread({}, this.qListeners), {}, {
          click: this.__onHeaderClick
        });

        if (this.hasLink === true) {
          Object.assign(data.props, this.linkProps.props);
          data.attrs = this.linkProps.attrs;
        }
      }

      return h(QItem, data, child);
    },
    __getContent: function __getContent(h) {
      var _this = this;

      var node = [this.__getHeader(h), h(QSlideTransition, {
        props: {
          duration: this.duration
        },
        on: cache(this, 'slide', {
          show: function show() {
            _this.$emit('after-show');
          },
          hide: function hide() {
            _this.$emit('after-hide');
          }
        })
      }, [h('div', {
        staticClass: 'q-expansion-item__content relative-position',
        style: this.contentStyle,
        directives: [{
          name: 'show',
          value: this.showing
        }]
      }, slot(this, 'default'))])];

      if (this.expandSeparator) {
        node.push(h(QSeparator, {
          staticClass: 'q-expansion-item__border q-expansion-item__border--top absolute-top',
          props: {
            dark: this.isDark
          }
        }), h(QSeparator, {
          staticClass: 'q-expansion-item__border q-expansion-item__border--bottom absolute-bottom',
          props: {
            dark: this.isDark
          }
        }));
      }

      return node;
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'q-expansion-item q-item-type',
      class: this.classes
    }, [h('div', {
      staticClass: 'q-expansion-item__container relative-position'
    }, this.__getContent(h))]);
  },
  created: function created() {
    this.group !== void 0 && this.$root.$on(eventName, this.__eventHandler);
  },
  beforeDestroy: function beforeDestroy() {
    this.group !== void 0 && this.$root.$off(eventName, this.__eventHandler);
  }
});